<div class="clinic-page">
  <div class="clinic-shell">
    <div class="clinic-toolbar">
      <div class="toolbar-top">
        <div class="toolbar-title">
          <h5>Clinic Management</h5>
          <small>Configure clinics, working hours, and appointment slot duration.</small>
        </div>
        <button type="button" class="add-btn" (click)="openCreateDialog()">
          <i class="pi pi-plus"></i>
          Add Clinic
        </button>
      </div>

      <div class="search-wrap">
        <i class="pi pi-search"></i>
        <input
          type="text"
          class="form-control"
          placeholder="Search clinics by name, city, or contact..."
          [(ngModel)]="searchTerm"
        />
      </div>
    </div>

    <div class="state-card" *ngIf="loading">
      <i class="pi pi-spin pi-spinner"></i>
      <span>Loading clinics...</span>
    </div>

    <div class="state-card" *ngIf="!loading && filteredClinics.length === 0">
      <i class="pi pi-building"></i>
      <span>No clinics found. Add your first clinic to get started.</span>
    </div>

    <div class="clinic-grid" *ngIf="!loading && filteredClinics.length > 0">
      <article class="clinic-card" *ngFor="let clinic of filteredClinics">
        <div class="clinic-card-head">
          <div>
            <h6>{{ clinic.name }}</h6>
            <span class="status-pill" [class.inactive]="clinic.status === 'inactive'">
              {{ clinic.status === 'inactive' ? 'Inactive' : 'Active' }}
            </span>
          </div>
          <div class="card-actions">
            <button type="button" class="icon-btn" title="Edit clinic" (click)="openEditDialog(clinic)">
              <i class="pi pi-pencil"></i>
            </button>
            <button type="button" class="icon-btn danger" title="Delete clinic" (click)="confirmDelete(clinic)">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </div>

        <div class="clinic-meta">
          <div class="meta-row" *ngIf="clinic.address || clinic.city">
            <i class="pi pi-map-marker"></i>
            <span>{{ clinic.address }}<ng-container *ngIf="clinic.city">, {{ clinic.city }}</ng-container></span>
          </div>
          <div class="meta-row" *ngIf="clinic.contact_number">
            <i class="pi pi-phone"></i>
            <span>{{ clinic.contact_number }}</span>
          </div>
        </div>

        <div class="schedule-summary">
          <div class="summary-block">
            <span class="label">Working Hours</span>
            <strong>{{ getScheduleSummary(clinic) }}</strong>
          </div>
          <div class="summary-block">
            <span class="label">Slot Duration</span>
            <strong>{{ getSlotLabel(clinic) }}</strong>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="dialogVisible"
  [modal]="true"
  [draggable]="false"
  [closable]="true"
  [showHeader]="false"
  styleClass="clinic-dialog"
  [style]="{ width: 'min(96vw, 58rem)' }"
  [contentStyle]="{ padding: '0', overflow: 'hidden' }"
>
  <div class="clinic-dialog-shell">
    <header class="clinic-dialog-hero">
      <div class="hero-copy">
        <div class="hero-icon">
          <i class="pi pi-building"></i>
        </div>
        <div>
          <p class="hero-eyebrow">{{ isEditing ? 'Update clinic' : 'New clinic' }}</p>
          <h3 class="text-white">{{ form.name.trim() || 'Clinic setup' }}</h3>
          <p class="hero-subtitle">Set location details, appointment slots, and weekly working hours.</p>
        </div>
      </div>

      <div class="hero-status">
        <button
          type="button"
          class="status-chip"
          [class.is-active]="form.status === 'active'"
          (click)="form.status = 'active'"
        >
          Active
        </button>
        <button
          type="button"
          class="status-chip inactive"
          [class.is-active]="form.status === 'inactive'"
          (click)="form.status = 'inactive'"
        >
          Inactive
        </button>
      </div>
    </header>

    <div class="clinic-dialog-steps">
      <button
        type="button"
        class="step-pill"
        [class.is-active]="dialogStep === 'details'"
        (click)="setDialogStep('details')"
      >
        <span class="step-index">1</span>
        Clinic details
      </button>
      <button
        type="button"
        class="step-pill"
        [class.is-active]="dialogStep === 'schedule'"
        (click)="setDialogStep('schedule')"
      >
        <span class="step-index">2</span>
        Schedule & slots
      </button>
    </div>

    <div class="clinic-dialog-body">
      <section class="dialog-panel" *ngIf="dialogStep === 'details'">
        <div class="panel-grid">
          <div class="panel-card">
            <div class="panel-card-head">
              <i class="pi pi-id-card"></i>
              <div>
                <h6>Basic information</h6>
                <small>Name and contact details patients will see.</small>
              </div>
            </div>

            <div class="field-stack">
              <div class="field-grid two-col">
                <div class="field">
                  <label>Clinic name <span class="req">*</span></label>
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="form.name"
                    placeholder="e.g. Mukund Nagar Clinic"
                  />
                </div>
                <div class="field">
                  <label>Contact number</label>
                  <div class="input-with-icon">
                    <i class="pi pi-phone"></i>
                    <input
                      pInputText
                      type="text"
                      [(ngModel)]="form.contact_number"
                      placeholder="+91 98765 43210"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel-card">
            <div class="panel-card-head">
              <i class="pi pi-map-marker"></i>
              <div>
                <h6>Location</h6>
                <small>Address used on certificates and patient records.</small>
              </div>
            </div>

            <div class="field-stack">
              <div class="field">
                <label>Street address</label>
                <textarea
                  pInputTextarea
                  rows="2"
                  [(ngModel)]="form.address"
                  placeholder="Building, street, landmark"
                ></textarea>
              </div>

              <div class="field-grid three-col">
                <div class="field">
                  <label>City</label>
                  <input pInputText type="text" [(ngModel)]="form.city" placeholder="Pune" />
                </div>
                <div class="field">
                  <label>State</label>
                  <input pInputText type="text" [(ngModel)]="form.state" placeholder="Maharashtra" />
                </div>
                <div class="field">
                  <label>Pincode</label>
                  <input pInputText type="text" [(ngModel)]="form.pincode" placeholder="411001" />
                </div>
              </div>

              <div class="field">
                <label>Country</label>
                <input pInputText type="text" [(ngModel)]="form.country" placeholder="India" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="dialog-panel" *ngIf="dialogStep === 'schedule'">
        <div class="schedule-layout">
          <div class="panel-card schedule-settings-card">
            <div class="panel-card-head">
              <i class="pi pi-clock"></i>
              <div>
                <h6>Appointment slots</h6>
                <small>Each booking uses one slot of this duration.</small>
              </div>
            </div>

            <div class="slot-chip-grid">
              <button
                type="button"
                class="slot-chip"
                *ngFor="let option of slotDurationOptions"
                [class.is-active]="form.slot_duration_minutes === option.value"
                (click)="setSlotDuration(option.value)"
              >
                {{ option.label }}
              </button>
            </div>

            <div class="preview-strip">
              <div class="preview-item">
                <span>Open days</span>
                <strong>{{ getOpenDaysCount() }}</strong>
              </div>
              <div class="preview-item">
                <span>Slot size</span>
                <strong>{{ getSlotDurationLabel() }}</strong>
              </div>
              <div class="preview-item wide">
                <span>Schedule</span>
                <strong>{{ getDialogPreviewSummary() }}</strong>
              </div>
            </div>
          </div>

          <div class="panel-card schedule-days-card">
            <div class="weekly-hours-head">
              <div class="weekly-hours-title">
                <div class="weekly-hours-icon">
                  <i class="pi pi-calendar"></i>
                </div>
                <div>
                  <h6>Weekly hours</h6>
                  <p>Set which days the clinic is open and the hours for appointments.</p>
                </div>
              </div>

              <div class="weekly-hours-stats">
                <span class="stat-chip">
                  <i class="pi pi-check-circle"></i>
                  {{ getOpenDaysCount() }} open
                </span>
                <span class="stat-chip muted">
                  <i class="pi pi-clock"></i>
                  {{ getSlotDurationLabel() }}
                </span>
              </div>
            </div>

            <div class="weekly-presets">
              <button type="button" class="preset-btn" (click)="applyWeekdayHours()">
                <i class="pi pi-briefcase"></i>
                Weekdays 9 AM – 9 PM
              </button>
              <button type="button" class="preset-btn" (click)="applyHoursToAllOpenDays()">
                <i class="pi pi-copy"></i>
                Copy first open day
              </button>
              <button type="button" class="preset-btn danger" (click)="closeAllDays()">
                <i class="pi pi-times-circle"></i>
                Close all days
              </button>
            </div>

            <div class="weekly-table">
              <div class="weekly-table-head">
                <span>Day</span>
                <span>Working hours</span>
                <span>Open</span>
              </div>

              <div class="weekly-table-body">
                <article
                  class="weekly-row"
                  *ngFor="let row of scheduleRows"
                  [class.is-open]="row.enabled"
                  [class.is-closed]="!row.enabled"
                  [class.is-weekend]="isWeekend(row.day)"
                >
                  <div class="weekly-row-day">
                    <span class="day-badge">{{ getShortDay(row.day) }}</span>
                    <div class="day-meta">
                      <strong>{{ row.day }}</strong>
                      <small *ngIf="row.enabled">{{ getEstimatedSlotsForRow(row) }} slots available</small>
                      <small *ngIf="!row.enabled">Not accepting appointments</small>
                    </div>
                  </div>

                  <div class="weekly-row-hours">
                    <ng-container *ngIf="row.enabled; else closedHours">
                      <div class="time-range-editor">
                        <label class="time-box">
                          <span class="time-box-label">Open</span>
                          <div class="time-box-input">
                            <input type="time" [(ngModel)]="row.open" />
                            <i class="pi pi-clock"></i>
                          </div>
                        </label>

                        <div class="time-range-divider" aria-hidden="true">
                          <span></span>
                        </div>

                        <label class="time-box">
                          <span class="time-box-label">Close</span>
                          <div class="time-box-input">
                            <input type="time" [(ngModel)]="row.close" />
                            <i class="pi pi-clock"></i>
                          </div>
                        </label>
                      </div>

                      <p class="hours-preview">{{ formatRowHours(row) }}</p>
                    </ng-container>

                    <ng-template #closedHours>
                      <div class="closed-hours">
                        <i class="pi pi-moon"></i>
                        <span>Closed for the day</span>
                      </div>
                    </ng-template>
                  </div>

                  <div class="weekly-row-toggle">
                    <p-inputSwitch
                      [ngModel]="row.enabled"
                      (ngModelChange)="toggleDay(row, $event)"
                    ></p-inputSwitch>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <footer class="clinic-dialog-footer">
      <button type="button" class="ghost-btn" (click)="dialogVisible = false">Cancel</button>

      <div class="footer-actions">
        <button
          type="button"
          class="ghost-btn"
          *ngIf="dialogStep === 'schedule'"
          (click)="setDialogStep('details')"
        >
          <i class="pi pi-arrow-left"></i>
          Back
        </button>

        <button
          type="button"
          class="next-btn"
          *ngIf="dialogStep === 'details'"
          (click)="setDialogStep('schedule')"
        >
          Continue to schedule
          <i class="pi pi-arrow-right"></i>
        </button>

        <button
          type="button"
          class="save-btn"
          *ngIf="dialogStep === 'schedule'"
          [disabled]="saving"
          (click)="saveClinic()"
        >
          <i class="pi" [ngClass]="saving ? 'pi-spin pi-spinner' : 'pi-check'"></i>
          {{ saving ? 'Saving...' : (isEditing ? 'Update clinic' : 'Create clinic') }}
        </button>
      </div>
    </footer>
  </div>
</p-dialog>

<p-confirmDialog></p-confirmDialog>
